export const styles = {
  // Clusters.jsx styles
  modalBox: (colors) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80vw",
    maxHeight: "80vh",
    overflow: "auto",
    bgcolor: colors.primary[400],
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  }),
  modalContent: {
    whiteSpace: "pre-wrap",
    fontFamily: "monospace",
  },
  RmoTypography: {
    whiteSpace: "pre-wrap",
    fontFamily: "monospace",
  },

  // index.jsx styles
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};
